module.exports = __webpack_public_path__ + "img/nt20-01-75-1.prt.c1199b7c.jpg";